<template>
  <v-container id="project-site-specification" fluid tag="section" class="main-container">
    <idc-component-bid-specification
      :settings="settings"
      :can-edit="false"
      :can-read="canRead"
      :can-delete="false"
      :can-clone="canClone"
      :url-paper-work="urlPaperWork"
      :url-equipment="urlEqupment"
    />
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'
  import Path from '@/utilities/bid/enums/Path'

  export default Vue.extend({
    name: 'DashboardProjectSpecification',
    components: {
      IdcComponentBidSpecification: () => import('@/components/idc/bids/Specification'),
    },
    props: {
      canRead: {
        type: Boolean,
        default: () => true,
      },
      canClone: {
        type: Boolean,
        default: () => true,
      },
      urlPaperWork: {
        type: String,
        default: () => Path.PROJECTS_PAPERWORK,
      },
      urlEqupment: {
        type: String,
        default: () => Path.PROJECTS_EQUIPMENT,
      },
    },
    computed: {
      ...mapState('Settings', ['settings']),
    },
  })
</script>
